import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CanDeactivateFn } from '@angular/router';
import { map } from 'rxjs';
import { DiscardChangesComponent } from '../dialogs/discard-changes/discard-changes.component';

export interface UnsavedChangesPage {
  hasUnsavedChanges(): boolean;
  isSaving(): boolean;
}

export const unsavedChangesGuard: CanDeactivateFn<UnsavedChangesPage> = (
  component, _currentRoute, _currentState, nextState,
) => {
  // Sign-out already happens before this navigation; leave that workflow unchanged.
  if (nextState.url.split(/[?#]/)[0] === '/authentication/signin') return true;
  if (!component.hasUnsavedChanges()) return true;
  // Do not discard an editor while its save request is still in flight.
  if (component.isSaving()) return false;

  const dialog = inject(MatDialog);
  const dialogRef = dialog.getDialogById('discard-unsaved-changes') ?? dialog.open(DiscardChangesComponent, {
    id: 'discard-unsaved-changes',
    width: '440px',
    maxWidth: '95vw',
    autoFocus: 'first-tabbable',
  });
  return dialogRef.afterClosed().pipe(map(discard => discard === true));
};
